import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ffc310",
      "fill-rule": "evenodd",
      d: "M18.818 14.125c-.616-.715-1.675-.678-2.503-.225A8.96 8.96 0 0 1 12 15a8.96 8.96 0 0 1-4.315-1.1c-.828-.453-1.887-.49-2.503.225A8.97 8.97 0 0 0 3 20v1a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-1a8.97 8.97 0 0 0-2.182-5.875",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#ff300b",
      d: "M17 6A5 5 0 1 1 7 6a5 5 0 0 1 10 0"
    }, null, -1)
  ]))]))
}
export default { render: render }